import { Link } from "react-router-dom";
import styles from "./MarketingFooter.module.css";

interface FooterLink {
  label: string;
  to: string;
}

const COLS: Array<{ title: string; links: FooterLink[] }> = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/#how-it-works" },
      { label: "Brand brain", to: "/#how-it-works" },
      { label: "Slack app", to: "/#slack" },
      { label: "Mobile", to: "/mobile" },
      { label: "API", to: "/api" },
    ],
  },
  {
    title: "Brands",
    links: [
      { label: "Ecommerce", to: "/#brand-kinds" },
      { label: "Service", to: "/#brand-kinds" },
      { label: "Creator", to: "/#brand-kinds" },
      { label: "Media", to: "/#brand-kinds" },
      { label: "Agency", to: "/pricing" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Pricing", to: "/pricing" },
      { label: "Changelog", to: "/changelog" },
      { label: "Docs", to: "/docs" },
      { label: "Status", to: "/status" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", to: "/legal/privacy" },
      { label: "Terms", to: "/legal/terms" },
      { label: "Security", to: "/security" },
      { label: "DPA", to: "/legal/dpa" },
      { label: "Contact", to: "mailto:hello@pheonixapps.com" },
    ],
  },
];

function isAnchor(to: string): boolean {
  return to.startsWith("/#");
}

function isExternal(to: string): boolean {
  return to.startsWith("mailto:") || /^https?:\/\//i.test(to);
}

export function MarketingFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <div className={styles.markRow}>
            <span className={styles.mark}>✻</span>
            <span className={styles.brandName}>Notamen</span>
          </div>
          <p className={styles.tagline}>
            A Phoenix Apps product. Made in Memphis, TN. Built on AWS + Anthropic.
          </p>
        </div>

        <div className={styles.cols}>
          {COLS.map((col) => (
            <div className={styles.col} key={col.title}>
              <div className={styles.colTitle}>{col.title}</div>
              <ul className={styles.colLinks}>
                {col.links.map((l) => (
                  <li key={l.label}>
                    {isExternal(l.to) ? (
                      <a href={l.to} className={styles.colLink}>
                        {l.label}
                      </a>
                    ) : isAnchor(l.to) ? (
                      <a href={l.to} className={styles.colLink}>
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.to} className={styles.colLink}>
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.bottom}>
        <span>© {new Date().getFullYear()} Phoenix Apps · socialmediamanager.pheonixapps.com</span>
        <span className={styles.build}>Private beta</span>
      </div>
    </footer>
  );
}
